var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"playthrough-report"},[(!_vm.playthrough)?_c('div',{staticStyle:{"height":"200px","display":"flex","align-items":"center","justify-content":"center"}},[_c('blade-spinner',{attrs:{"nested":"","noBackground":""}})],1):_c('div',[_c('playthrough-metric-chart',{attrs:{"playthrough":_vm.playthrough}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-383f716e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blade/pages/PlaythroughReport.vue
// module id = null
// module chunks = 